module.exports = __webpack_public_path__ + "static/img/manual-6.04f388c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/manual-6.png
// module id = 6h7R
// module chunks = 4